<!-- 上报及办理量对比 -->
<template>
    <div class='wrapper_mm'>
        <div class="title">老人年龄及性别统计</div>
        <div  id="echart_xxx_tj" style="width:100%;height:80%" v-show="show"></div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            mon:[],
            submitList:[],
            solveList:[],
            handelTag:'',
            show:false
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            // this.$get(this.urlobj.monitor_eventFinishMonth).then(res=>{
            //     this.mon = res.rows.map(item=>item.creatTime)
            //     //let handelData = res.rows.map(item=>item.handleCount)
            //     //this.handelData = this.$util.handleNumber(handelData).numArr
            //     //this.handelTag = this.$util.handleNumber(handelData).tag
            //     this.submitList = res.rows.map(item=>{
            //         return {
            //             value: item.totalCount,
            //             symbolOffset: [0, -8],
            //             symbol: `image://${require("../../../../assets/images/monitorpy/bar_blue.png")}`
            //         }
            //     })
            //     this.solveList = res.rows.map(item=>{
            //         return {
            //             value: item.finishedCount,
            //             symbolOffset: [0, -8],
            //             symbol: `image://${require("../../../../assets/images/monitorpy/bar_green.png")}`
            //         }
            //     })
                
                this.$nextTick(()=>{
                    this.initEcharts()
                })
            // })
        },
        initEcharts(){
            
            let echart = echarts.init(document.getElementById('echart_xxx_tj'));

            let option = {
                tooltip: {
                    trigger: "axis",
                    backgroundColor:'rgba(255,255,255,0)',
                    formatter: ( params ) => {

                        let data = []
                        params.forEach( item => {
                            if( item.value < 0 ) {
                                item.value = (0 - item.value)
                            }
                            data.push(   '<span style="display:inline-block;margin-left:-7px;margin-right:5px">年龄:</span>' + item.axisValue + '<br/>' + `<span style="display:inline-block;margin-left:-7px;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color.colorStops[0].color}"></span>` + item.seriesName +':'+ item.value + ' <br />' )
                        } ) 
                        return data 
                    }
                },
                grid: {
                    containLabel: true,
                    left: '10%',
                    top: "10%",
                    bottom: "10%",
                },
                legend: {
                    data: ["女性", "男性"],
                    textStyle: {
                        color: "#fff",
                    },
                    // top: 30,
                    left: 'center',
                    itemWidth: 16,
                    itemHeight:12
                },

                xAxis: {
                    axisLine: {
                        lineStyle: {
                            color: "#999da0",
                        },
                        show: false,
                    },

                    axisLabel: {
                        color: "#9e9e9c",
                        fontSize: 12,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                    },
                },
                yAxis: {
                    name:'',
                    axisLine: {
                        lineStyle: {
                            color: "#9e9e9c",
                        },
                    },
                    axisLabel: {
                        show: true,
                        color: "#9e9e9c",
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    data: [6,7,8,9,10],
                },

                series: [
                    {
                        name: "女性",
                        type: "bar",
                        itemStyle: {
                              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: '#fd97e0' },
                                { offset: 1, color: "#ff48be" }
                              ]),
                            barBorderRadius: 5,
                        },
                        barWidth: "20%",
                        stack: '总量',
                        data: [1,2,3,4,5],
                    },
                    {
                        name: "男性",
                        type: "bar",
                        itemStyle: {
                              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: '#8ed5ff' },
                                { offset: 1, color: "#00b9e8" }
                              ]),
                            barBorderRadius: 5,
                        },
                        barWidth: "20%",
                        stack: '总量',
                        data: [-1,-2,-3,-4,-5],
                    },
                ],
            }
            

            echart.setOption(option)

        }
        
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.show = true
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getData()
        
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper_mm{
    height:100%!important;
    width:100%!important;
    background-image: url('../../../../assets/images/monitorpy/rightbottom.png');
    background-size: 100% 100%;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    padding-left: 40px;
    padding-top: 20px;
    box-sizing:border-box
}

</style>